/**
 * Tradução centralizada das mensagens de erro de autenticação para PT-BR.
 * Nunca exibir o texto original em inglês para o usuário final.
 */

const RULES: { match: RegExp; message: string }[] = [
  {
    match: /known to be weak|pwned|weak and easy to guess/i,
    message: 'Essa senha é muito comum e fácil de adivinhar. Escolha uma senha mais forte.',
  },
  {
    match: /password should be at least|password is too short|minimum.*characters/i,
    message: 'A senha é muito curta. Use pelo menos 8 caracteres.',
  },
  {
    match: /already registered|already been registered|user already exists|duplicate key.*email/i,
    message: 'Este e-mail já possui uma conta. Use "Esqueci minha senha" para recuperar o acesso.',
  },
  {
    match: /invalid login credentials/i,
    message: 'E-mail ou senha incorretos. Verifique seus dados e tente novamente.',
  },
  {
    match: /email not confirmed/i,
    message: 'Seu e-mail ainda não foi confirmado. Verifique sua caixa de entrada.',
  },
  {
    match: /over_email_send_rate_limit|email rate limit exceeded/i,
    message: 'Muitos e-mails enviados em pouco tempo. Aguarde alguns minutos e tente novamente.',
  },
  {
    match: /over_request_rate_limit|too many requests|rate limit/i,
    message: 'Muitas tentativas em pouco tempo. Aguarde alguns instantes e tente novamente.',
  },
  {
    match: /user not found/i,
    message: 'Não encontramos uma conta com esses dados.',
  },
  {
    match: /token has expired|otp_expired|invalid or has expired/i,
    message: 'Este link expirou. Solicite um novo e tente novamente.',
  },
  {
    match: /unable to validate email address|invalid email/i,
    message: 'E-mail inválido. Verifique o endereço digitado.',
  },
  {
    match: /same as the old password|new password should be different/i,
    message: 'A nova senha precisa ser diferente da senha atual.',
  },
  {
    match: /signups not allowed|signup is disabled/i,
    message: 'Os cadastros estão temporariamente desativados.',
  },
  {
    match: /network|fetch failed|failed to fetch/i,
    message: 'Falha de conexão. Verifique sua internet e tente novamente.',
  },
];

const FALLBACK = 'Não foi possível concluir a operação. Tente novamente em alguns instantes.';

/** Recebe um erro (Supabase, Error ou string) e devolve mensagem em português. */
export function translateAuthError(error: unknown, fallback: string = FALLBACK): string {
  const raw =
    typeof error === 'string'
      ? error
      : (error as { message?: string })?.message || '';

  if (!raw) return fallback;

  for (const rule of RULES) {
    if (rule.match.test(raw)) return rule.message;
  }

  // Se a mensagem já está em português (heurística simples), mantém.
  if (/[áàâãéêíóôõúç]/i.test(raw)) return raw;

  return fallback;
}
